import { Injectable, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
// import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AlertWindowComponent } from 'src/app/common/alert-window/alert-window.component';
import { FullSpinnerService } from 'src/app/common/full-spinner/full-spinner.service';
import { BatchStockdetailsComponent } from 'src/app/select-modal/batch-stockdetails/batch-stockdetails.component';
import { RatewiseCurrentstockComponent } from 'src/app/select-modal/ratewise-currentstock/ratewise-currentstock.component';
import { SelectSerialInvoiceComponent } from 'src/app/select-modal/select-serial-invoice/select-serial-invoice.component';
import { SelectserialStockreqNoitemComponent } from 'src/app/select-modal/selectserial-stockreq-noitem/selectserial-stockreq-noitem.component';
import { DataService } from 'src/app/service/data.service';
import { MultigodownSelectionComponent } from 'src/app/select-modal/multigodown-selection/multigodown-selection.component';
import { MatrixSelectionComponent } from 'src/app/select-modal/matrix-selection/matrix-selection.component';

@Injectable({
  providedIn: 'root'
})
export class SalesInvoiceService {
  id = '';
  fycode = '';
  brcode = '';
  godowns = [];
  responseData: any;
  loadingTrue = true;
  CloadingTrue = false;
  addloadingTrue = false;
  tableLoading = false;
  btnClicked = false;
  savebtnClicked = false;
  priceUpdate = false;
  editmode = false;
  salesamount: '';
  customeradvances = [];
  button = '';
  customerPOTrue = false;
  lastsalerate = '';
  lastsaleratetrue = false;
  manualbillno = '';
  scanbarcode = '';
  scanbarcodeid = '';
  barcode = '';
  barcoderefn = '';
  dcnos = [];
  searchItem = {
    type: 'NAME',
    text: ''
  };
  customer = {
    advanced: {
      addressline01: '',
      addressline02: '',
      addressline03: '',
      addressline04: '',
      gstin: '',
      dob: '',
      dow: '',
      customergroupcode: '',
      countrycode: '',
      statecode: '',
      citycode: '',
      taxtype: '',
      gsttype: '',
      taxinclusive: '',
      pricetypecode: '',
      pricelistcode: '',
      discountlistcode: '',
      rewardrequired: '',
      cesscalculation: '',
      custcurrencycode: '',
      custcurrencyid: '',
      creditdays: '',
      billdiscountper: ''
    },
    partycontacts: [],
    customeraddresses: [],
    customercode: '',
    customerid: '',
    customername: '',
    mobileno: '',
    emailid: '',
    transdetails: {
      balancerewardpoints: '',
      balancerewardvalue: '',
      lastbilleddate: '',
      lastbilledvalue: '',
      yearbilledvalue: '',
      customerreceivables: ''
    },
  };
  currency = {
    currencycode: '',
    currencyid: '',
    currencyname: '',
    currencyvalue: '',
    decimalplaces: '',
    roundoff: ''
  };
  customercode = '';
  selectedItem = {
    ic: '',
    refn: '',
    ina: '',
    sr: '',
    srafterdisc: '',
    srorg: '',
    mrp: '',
    currencysrorg: '',
    value: '',
    valueorg: '',
    taxvalue: '',
    discvalue: '',
    srwithtax: '',
    valuewithtax: '',
    qty: '',
    dp: '',
    tc: '',
    tp: '',
    sq: '',
    fd: '',
    bc: '',
    sdp: '',
    schemediscvalue: '',
    serialnumbers: [],
    reffield2: [],
    reffield3: [],
    reffield4: [],
    reffield5: [],
    reffield6: [],
    reffield7: [],
    reffield8: [],
    reffield9: [],
    reffield10: [],
    serialgodowncodes: [],
    serialgodownnames: [],
    batchno: '',
    mfgdate: '',
    expdate: '',
    description: '',
    ac: '',
    mrp_profitper: '',
    mrp_profitamt: '',
    sr_profitper: '',
    sr_profitamt: '',
    description2: '',
    description3: '',
    description4: '',
    description5: '',
    cesspercent: '',
    cessamount: '',
    dispname: '',
    extracessrate: '',
    extracessamount: '',
    uom: '',
    sgstpercent: '',
    sgstamount: '',
    cgstpercent: '',
    cgstamount: '',
    igstpercent: '',
    igstamount: '',
    mfrname: '',
    hsncode: '',
    hsnrefno: '',
    matrix1code: '',
    matrix1id: '',
    matrix1name: '',
    matrix2code: '',
    matrix2id: '',
    matrix2name: '',
    matrix3code: '',
    matrix3d: '',
    matrix3name: '',
    matrix4code: '',
    matrix4id: '',
    matrix4name: '',
    matrix5code: '',
    matrix5id: '',
    matrix5name: '',
    matrix6code: '',
    matrix6id: '',
    matrix6name: '',
    matrix7code: '',
    matrix7id: '',
    matrix7name: '',
    matrix8code: '',
    matrix8id: '',
    matrix8name: '',
    matrix9code: '',
    matrix9id: '',
    matrix9name: '',
    matrix10code: '',
    matrix10id: '',
    matrix10name: '',
    reftype: '',
    salespersoncode: '',
    salespersonname: '',
    returnbalqty: '',
    dcbillbalqty: '',
    rowno: '',
    dcdetails: [],
    editbeforedetails: {
      srorg: '',
      batchno: '',
      bc: '',
      matrix1code: '',
      matrix2code: '',
      matrix3code: '',
      matrix4code: '',
      matrix5code: '',
      matrix6code: '',
      matrix7code: '',
      matrix8code: '',
      matrix9code: '',
      matrix10code: ''
    },
    godowndetail: [],
    ssr: ''
  };
  itemRestoreData = {
    ic: '',
    refn: '',
    qr: '',
    srorg: '',
    currencysrorg: '',
    mrp: '',
    value: '',
    valueorg: '',
    taxvalue: '',
    discvalue: '',
    srwithtax: '',
    srafterdisc: '',
    valuewithtax: '',
    qty: '',
    dp: '',
    tc: '',
    tp: '',
    sq: '',
    fd: '',
    bc: '',
    sdp: '',
    schemediscvalue: '',
    ac: '',
    mrp_profitper: '',
    mrp_profitamt: '',
    sr_profitper: '',
    sr_profitamt: '',
    sgstpercent: '',
    sgstamount: '',
    cgstpercent: '',
    cgstamount: '',
    igstpercent: '',
    igstamount: '',
    reftype: '',
    cesspercent: '',
    cessamount: '',
    extracessrate: '',
    extracessamount: ''
  };
  itemDetails = {
    serialdetails: {
      reffield2: {
        required: '',
        mandatory: ''
      },
      reffield3: {
        required: '',
        mandatory: ''
      },
      reffield4: {
        required: '',
        mandatory: ''
      },
      reffield5: {
        required: '',
        mandatory: ''
      },
      reffield6: {
        required: '',
        mandatory: ''
      },
      reffield7: {
        required: '',
        mandatory: ''
      },
      reffield8: {
        required: '',
        mandatory: ''
      },
      reffield9: {
        required: '',
        mandatory: ''
      },
      reffield10: {
        required: '',
        mandatory: ''
      },
      reffielddisplaycolumns: []
    },
    matrixsetup: {
      matrix1: {
        required: ''
      },
      matrix2: {
        required: ''
      },
      matrix3: {
        required: ''
      },
      matrix4: {
        required: ''
      },
      matrix5: {
        required: ''
      },
      matrix6: {
        required: ''
      },
      matrix7: {
        required: ''
      },
      matrix8: {
        required: ''
      },
      matrix9: {
        required: ''
      },
      matrix10: {
        required: ''
      },
      matrixheaddisplaycolumns: [],
      matrixnamedisplaycolumns: []
    },
    branchwiseminmaxstocks: [],
    branchwisemrpdiscounts: [],
    branchwisepricing: [],
    branchwiseproducts: [],
    multibarcodes: [],
    quantitypricesetup: {
      qtywisepricing: []
    },
    margindetails: {
      mrpmargindetails: {
        mrpdisc1per: '',
        mrpdisc2per: '',
        mrpmargin: '',
        mrpmarkupper: '',
        mrpmarkdownper: '',
        mrpnetmargin: '',
        mrpnetmarginper: ''
      },
      purchasedetails: {
        prdiscper: '',
        prtaxvalue: '',
        prwithtax: ''
      },
      salesmargindetails: {
        srdiscper: '',
        srwithouttax: '',
        srtaxvalue: '',
        srmargin: '',
        srmarkupper: '',
        srmarkdownper: '',
        srnetmargin: '',
        srnetmarginper: ''
      },
      priceschemes: {
        dlrpdiscper: '',
        dlrpmarginper: '',
        dlrpmarginvalue: '',
        p1discper: '',
        p1marginper: '',
        p1marginvalue: '',
        p2discper: '',
        p2marginper: '',
        p2marginvalue: '',
        p3discper: '',
        p3marginper: '',
        p3marginvalue: '',
        p4discper: '',
        p4marginper: '',
        p4marginvalue: '',
        p5discper: '',
        p5marginper: '',
        p5marginvalue: '',
        p6discper: '',
        p6marginper: '',
        p6marginvalue: ''
      },
      roundoffnetvalues: ''
    },

    ic: '',
    ina: '',
    refn: '',
    sr: '',
    tp: '',
    cc: '',
    dp: '',
    da: '',
    unit: '',
    itemactive: '',
    reftype: '',
    stkchk: '',
    hsncode: '',
    taxcode: '',
    sq: '',
    fd: '',
    uomcode: '',
    subuomcode: '',
    mpchk: '',
    pr: '',
    mrp: '',
    dlrp: '',
    bc: '',
    bcm: '',
    pcm: '',
    p1: '',
    p2: '',
    p3: '',
    p4: '',
    p5: '',
    p6: '',
    d1: '',
    d2: '',
    d3: '',
    d4: '',
    d5: '',
    d6: '',
    netwt: '',
    grswt: '',
    imc: '',
    ilc: '',
    origincode: '',
    onlineallowed: '',
    mfgdateyn: '',
    expdays: '',
    cc2: '',
    cc3: '',
    cc4: '',
    cc5: '',
    itemtypecode: '',
    cesspercent: '',
    extracessrate: ''
  };
  matrixsetup = {
    matrix1: {
      required: '',
      caption: ''
    },
    matrix2: {
      required: '',
      caption: ''
    },
    matrix3: {
      required: '',
      caption: ''
    },
    matrix4: {
      required: '',
      caption: ''
    },
    matrix5: {
      required: '',
      caption: ''
    },
    matrix6: {
      required: '',
      caption: ''
    },
    matrix7: {
      required: '',
      caption: ''
    },
    matrix8: {
      required: '',
      caption: ''
    },
    matrix9: {
      required: '',
      caption: ''
    },
    matrix10: {
      required: '',
      caption: ''
    },
  };
  salesData = {
    tempsalesno: '',
    manualbillno: '',
    displaysalesno: '',
    branchcode: '',
    finyearcode: '',
    customercode: '',
    customername: '',
    address: '',
    salesdate: moment().format('DD/MM/YYYY'),
    customerpo: '',
    customerpodate: '',
    creditdays: '',
    salesnotes: '',
    paymentterms: '',
    deliverymode: '',
    noofpackages: '',
    ewaybillrefno: '',
    salestypecode: '',
    salestypename: '',
    salesaccountcode: '',
    salesaccountname: '',
    receiptmodecode: '',
    receiptmodename: '',
    costcentercode: '',
    costcentername: '',
    salestaxtype: '',
    salestaxinclusive: '',
    salesgsttype: '',
    currencyexchangerate: '',
    salescurrencycode: '',
    salescurrencyid: '',
    salesnetcurrencyvalue: '',
    subtotalamount: '',
    subtotalamountorg: '',
    billdiscountpercent: '',
    billdiscountamount: '',
    netamount: '',
    cashamount: '',
    cardamount: '',
    creditamount: '',
    chequeamount: '',
    freeamount: '',
    couponamount: '',
    othercardamount: '',
    rewardspentamount: '',
    returnadjustamount: '',
    tempexchangeno: '',
    nextsalesreminddate: '',
    bankcode: '',
    bankname: '',
    refno: '',
    date: '',
    tenderedamount: '',
    balancetopay: '',
    creditcardno: '',
    ourbankcode: '',
    ourbankname: '',
    cardtypecode: '',
    cardholdername: '',
    cardtypename: '',
    cardcompanytypecode: '',
    cardcompanytypename: '',
    cardservicechargespercent: '',
    cardservicechargesvalue: '',
    despatchaddress1: '',
    despatchaddress2: '',
    despatchaddress3: '',
    despatchaddress4: '',
    salespersoncode: '',
    salespersonname: '',
    totaltax: '',
    totalsgst: '',
    totalcgst: '',
    totaligst: '',
    totalgst: '',
    totalcharges: '',
    roundoffamount: '',
    createdby: '',
    createddatetime: '',
    approved: '',
    approvedby: '',
    approveddatetime: '',
    approval_timetaken: '',
    approval_timeelapsed: '',
    srallowed: '',
    contactcode: '',
    contactname: '',
    contactno: '',
    emailid: '',
    workphoneno: '',
    department: '',
    designation: '',
    exchangeno: '',
    dcwithtax: '',
    dcreturnable: '',
    dcbillable: '',
    dcreturnduedate: '',
    invoiceallowed: '',
    basedonno: '',
    basedondate: '',
    basedonname: '',
    questioncode: '',
    questionanswer: '',
    holdbill: 'NO',
    addbybarcode: 'NO',
    totalqty: 0,
    walletbankcode: '',
    entryupdatemode: '',
    salesentrytypename: 'SALES_INVOICE',
    available_items: [],
    unavailable_items: [],
    charges: [],
    taxsummary: [],
    documents: [],
    termsandconditions: [],
    advanceadjustments: [],
    returnadjustments: [],
    coupondetails: [],
    items: [],

    coupontotalsummary: {
      couponcount: '',
      copuonvalue: '',
      chargesvalue: '',
      couponnetvalue: ''
    },
    ewaybilldetails: {
      transportmodecode: '1',
      transportmodename: '',
      transportdistance: '0',
      transportid: '',
      transportname: '',
      transportdocno: '',
      transportdate: '',
      vehicleno: '',
      vehicletypecode: '1',
      vehicletypename: ''
    }
  };
  singleItem = {
    available_items: [],
    tempsalesno: '',
    netamount: '',
  };
  discounts = {
    billdiscountpercent: '',
    billdiscountamount: ''
  };
  defC: any = {
    allcolumns: {
      slno: {
        displayname: ''
      },
      ic: {
        displayname: ''
      },
      refn: {
        displayname: ''
      },
      ina: {
        displayname: ''
      },
      sr: {
        displayname: ''
      },
      srafterdisc: {
        displayname: ''
      },
      srorg: {
        displayname: ''
      },
      mrp: {
        displayname: ''
      },
      currencysrorg: {
        displayname: ''
      },
      value: {
        displayname: ''
      },
      valueorg: {
        displayname: ''
      },
      taxvalue: {
        displayname: ''
      },
      discvalue: {
        displayname: ''
      },
      valuewithtax: {
        displayname: ''
      },
      qty: {
        displayname: ''
      },
      dp: {
        displayname: ''
      },
      tc: {
        displayname: ''
      },
      tp: {
        displayname: ''
      },
      sq: {
        displayname: ''
      },
      fd: {
        displayname: ''
      },
      bc: {
        displayname: ''
      },
      batchno: {
        displayname: ''
      },
      mfgdate: {
        displayname: ''
      },
      expdate: {
        displayname: ''
      },
      description: {
        displayname: ''
      },
      ac: {
        displayname: ''
      },
      mrp_profitper: {
        displayname: ''
      },
      mrp_profitamt: {
        displayname: ''
      },
      sr_profitper: {
        displayname: ''
      },
      sr_profitamt: {
        displayname: ''
      },
      description2: {
        displayname: ''
      },
      description3: {
        displayname: ''
      },
      description4: {
        displayname: ''
      },
      description5: {
        displayname: ''
      },
      dispname: {
        displayname: ''
      },
      extracessrate: {
        displayname: ''
      },
      extracessamount: {
        displayname: ''
      },
      uom: {
        displayname: ''
      },
      mfrname: {
        displayname: ''
      },
      hsncode: {
        displayname: ''
      },
      hsnrefno: {
        displayname: ''
      },
      matrix1id: {
        displayname: ''
      },
      matrix1name: {
        displayname: ''
      },
      matrix2id: {
        displayname: ''
      },
      matrix2name: {
        displayname: ''
      },
      matrix3id: {
        displayname: ''
      },
      matrix3name: {
        displayname: ''
      },
      matrix4id: {
        displayname: ''
      },
      matrix4name: {
        displayname: ''
      },
      matrix5id: {
        displayname: ''
      },
      matrix5name: {
        displayname: ''
      },
      matrix6id: {
        displayname: ''
      },
      matrix6name: {
        displayname: ''
      },
      matrix7id: {
        displayname: ''
      },
      matrix7name: {
        displayname: ''
      },
      matrix8id: {
        displayname: ''
      },
      matrix8name: {
        displayname: ''
      },
      matrix9id: {
        displayname: ''
      },
      matrix9name: {
        displayname: ''
      },
      matrix10id: {
        displayname: ''
      },
      matrix10name: {
        displayname: ''
      },
      reftype: {
        displayname: ''
      },
      salespersoncode: {
        displayname: ''
      },
      salespersonname: {
        displayname: ''
      }
    },
    displaycolumns: []
  };
  displayColumn: any = [];
  ewayBillDetails = {
    einvoice_irn: '',
    eway_billno: '',
    eway_billdatetime: '',
    einvoice_irn_qr_image_base64: '',
    signed_invoice: '',
    signed_qrcode: '',
    ackno: '',
    ackdate: '',
    einvoice_cancelled: '',
    einvoice_cancelled_datetime: '',
    eway_billcancelled: '',
    transportmodecode: '1',
    transportmodename: '',
    transportdistance: '0',
    transportid: '',
    transportname: '',
    transportdocno: '',
    transportdate: '',
    vehicleno: '',
    vehicletypecode: '1',
    vehicletypename: '',
    cancelledreasonnotes: '',
  }
  batchstocks = '';
  constructSerials = [];
  xbilldiscount = '';
  xbilldiscamount = '';
  xrate = '';
  xdisc = '';
  xqty = '';
  getDataObservable: Subject<any> = new Subject();
  orderno = '';
  buttonEditTrue = false;
  dcdetails = [];
  @ViewChild('ic', { static: false }) ic;
  constructor(
    public storage: Storage,
    public data: DataService,
    public dialog: MatDialog,
    public router: Router,
    public fullspinner: FullSpinnerService
  ) { }


  getDefaultValue() {
    if (this.data.token !== '') {
      this.tableLoading = true;
      this.data.getData('screencolumn/sales').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.defC = this.responseData.data;
          this.defC.displaycolumns.push('remove');
        }
        this.tableLoading = false;
      }, (error) => {
        this.tableLoading = false;
      });
    } else {
      setTimeout(() => {
        this.getDefaultValue();
      }, 400);
    }
  }

  checkForPending() {
    this.storage.get('salesData').then((val) => {
      if (val) {
        this.draftItemRestore(val);
      } else {
        setTimeout(() => {
          this.clearAllTempData();
          this.clearSelectedItem();
        }, 400);
        this.getSalesDefaultData();
      }
    });
  }

  draftItemRestore(el): void {
    const dialogRef = this.dialog.open(AlertWindowComponent, {
      width: '350px',
      data: {
        msg: 'Do you want to restore the draft Sales '
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getTempData(el.tempsalesno);
      } else {
        this.clearAllTempData();
        this.storage.remove('salesData');
        this.storage.remove('orderno');
        this.orderno = '';
        setTimeout(() => {
          this.getSalesDefaultData();
        }, 400);
      }
    });
  }

  getNewDisplayID(val) {
    if (this.id != this.salesData.displaysalesno && this.data.authorizationResponse.softwaresetup.data.salesno_gentype_code === '3') {
      const obj = {
        salestypecode: this.salesData.salestypecode,
        branchcode: this.data.brcode,
        finyearcode: this.data.fycode,
      };
      this.data.postData('sales/newdisplayno', obj).then((result) => {
        this.responseData = result;
        if (this.responseData.Status === true) {
          this.salesData.displaysalesno = this.responseData.displaysalesno;
        }
        if (val) {
          // this.data.openAlert(this.responseData);
        }
        this.loadingTrue = false;
      }, (err) => {
        this.loadingTrue = false;
      });
    }
  }

  getTempData(tempid): void {
    this.addloadingTrue = false;
    const obj = {
      "entryno": tempid,
      "entryfinyearcode": this.fycode,
      "entrybranchcode": this.brcode,
      "salesentrytypename": "SALES_INVOICE"
    };
    this.data.postData('sales/detail', obj).then((success) => {
      // this.data.getData('sales/' + tempid + '/detail').then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.salesData = this.responseData.data;
        this.discounts.billdiscountpercent = this.responseData.data.billdiscountpercent;
        this.discounts.billdiscountamount = this.responseData.data.billdiscountamount;
        // this.salesData.salesdate = moment(this.responseData.data.salesdate, 'DD/MM/YYYY').format('DD MMM YYYY');
        // const xydata = JSON.parse(JSON.stringify(this.salesData));
        // this.xbilldiscount = xydata.billdiscountpercent;
        // this.xbilldiscamount = xydata.billdiscountamount;
        this.dcdetails = [];
        this.dcnos = [];
        console.log(this.salesData);
        if (this.salesData.basedonname === "DC") {
          const dcData = this.salesData.available_items.map((e) => e.dcdetails)
          dcData.forEach(element => {
            this.dcdetails.push(element);
            element.forEach(element1 => {
              this.dcnos.push(element1.dcno);
            });
          });
        }


        this.addloadingTrue = false;
        this.storage.set('salesData', this.salesData);
        this.customercode = this.salesData.customercode;
        this.customerChanged(false);
        this.getSalesDocuments();
      } else {
        this.clearAll();
        this.clearAllTempData();
      }
    }, (error) => {
      this.addloadingTrue = false;
    });
  }

  getSalesDefaultData(): void {
    if (this.data.token !== '') {
      this.loadingTrue = true;
      const obj = {
        "entryno": '0',
        "entryfinyearcode": this.fycode,
        "entrybranchcode": this.brcode,
        "salesentrytypename": "SALES_INVOICE"
      };
      this.data.postData('sales/detail', obj).then((success) => {
        // this.data.getData('sales/0/detail').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.salesData = this.responseData.data;
          this.discounts.billdiscountpercent = this.responseData.data.billdiscountpercent;
          this.discounts.billdiscountamount = this.responseData.data.billdiscountamount;
          // const xydata = JSON.parse(JSON.stringify(this.salesData));
          // this.xbilldiscount = xydata.billdiscountpercent;
          // this.xbilldiscamount = xydata.billdiscountamount;
          this.loadingTrue = false;
          this.salesData.customercode = '';
          this.salesData.tempsalesno = '';
          this.customercode = this.salesData.customercode;
          this.customerChanged(true);
          // this.clearSelectedItem();
          this.getNewDisplayID(false);
          setTimeout(() => {
            this.salesData.salespersoncode = this.data.authorizationResponse.salespersoncode;
          }, 400);
        } else {
          this.clearAll();
          this.clearAllTempData();
        }
      }, (error) => {
        this.loadingTrue = false;
      });
    } else {
      setTimeout(() => {
        this.getSalesDefaultData();
      }, 400);
    }
  }

  customerChanged(val) {
    if (this.customercode !== '') {
      this.storage.get('orderno').then((val) => {
        if (val) {
          this.orderno = val;
        }
      });
      this.CloadingTrue = true;
      this.data.getData('customer/' + this.customercode + '/withdetails').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.customer = this.responseData.data;
          this.salesData.customercode = this.customer.customercode;
          if (this.salesData.entryupdatemode === 'NO') {
            this.storage.get('creditDays').then((val:any)=>{
              if(val){
                this.storage.remove('creditDays')
              }
              else{
                this.salesData.creditdays = this.customer.advanced.creditdays;
              }
            })
          
          }

          if (val) {
            this.salesData.salestaxtype = this.customer.advanced.taxtype;
            this.salesData.salescurrencycode = this.customer.advanced.custcurrencycode;
            this.salesData.salesgsttype = this.customer.advanced.gsttype;
          }
          if (this.customer.customeraddresses.length === 0) {
            this.salesData.despatchaddress1 = this.customer.advanced.addressline01;
            this.salesData.despatchaddress2 = this.customer.advanced.addressline02;
            this.salesData.despatchaddress3 = this.customer.advanced.addressline03;
            this.salesData.despatchaddress4 = this.customer.advanced.addressline04;
          } else {
            this.salesData.despatchaddress1 = this.customer.customeraddresses[0].address1;
            this.salesData.despatchaddress2 = this.customer.customeraddresses[0].address2;
            this.salesData.despatchaddress3 = this.customer.customeraddresses[0].address3;
            this.salesData.despatchaddress4 = this.customer.customeraddresses[0].address4;
          }
          if (this.data.authorizationResponse.softwaresetup.data.salesdisc_tobe_takenfrom === '3' && this.salesData.available_items.length <= 0) {
            this.getCustomerGroup();
          }

          if (this.data.authorizationResponse.softwaresetup.data.salesdisc_tobe_takenfrom === '1' && this.salesData.available_items.length <= 0) {
            this.salesData.billdiscountpercent = this.customer.advanced.billdiscountper;
          }

          setTimeout(() => {
            this.getCurrenyDetails(val);
            this.getCustomerAdvaces();
          }, 400);
          this.CloadingTrue = false;
        }
      }, (error) => { });
    }
  }

  getCustomerGroup() {
    this.data.getData('customergroup/' + this.customer.advanced.customergroupcode).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.salesData.billdiscountpercent = this.responseData.data.salesdiscountpercent;
      }
    })
  }

  getCurrenyDetails(value) {
    this.storage.get('authorizationResponse').then((val) => {
      if (val) {
        if (val.softwaresetup.data.multicurrencyonsales === 'YES') {
          this.data.getData('currency/' + this.customer.advanced.custcurrencycode).then((success) => {
            this.responseData = success;
            if (this.responseData.Status === true) {
              this.currency = this.responseData.data;
              if (value) {
                this.salesData.salescurrencycode = this.customer.advanced.custcurrencycode;
                this.salesData.currencyexchangerate = this.currency.currencyvalue;
              }
            } else {
              this.currency = {
                currencycode: '',
                currencyid: '',
                currencyname: '',
                currencyvalue: '',
                decimalplaces: '',
                roundoff: ''
              };
            }
          }, (error) => { });
        }
      }
    });
  }

  UpdateOtherDetails() {
    this.data.postData('update/sales/otherdetails', this.salesData).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        // this.storage.set('pData', this.pData);
      }
    }, (error) => { });
  }

  clearAll() {
    this.customer = {
      advanced: {
        addressline01: '',
        addressline02: '',
        addressline03: '',
        addressline04: '',
        gstin: '',
        dob: '',
        dow: '',
        customergroupcode: '',
        countrycode: '',
        statecode: '',
        citycode: '',
        taxtype: '',
        gsttype: '',
        taxinclusive: '',
        pricetypecode: '',
        pricelistcode: '',
        discountlistcode: '',
        rewardrequired: '',
        cesscalculation: '',
        custcurrencycode: '',
        custcurrencyid: '',
        creditdays: '',
        billdiscountper: ''
      },
      partycontacts: [],
      customeraddresses: [],
      customercode: '',
      customerid: '',
      customername: '',
      mobileno: '',
      emailid: '',
      transdetails: {
        balancerewardpoints: '',
        balancerewardvalue: '',
        lastbilleddate: '',
        lastbilledvalue: '',
        yearbilledvalue: '',
        customerreceivables: ''
      },
    };
    this.customercode = '';
    this.currency = {
      currencycode: '',
      currencyid: '',
      currencyname: '',
      currencyvalue: '',
      decimalplaces: '',
      roundoff: ''
    };
    this.manualbillno = '';
    this.loadingTrue = false;
    this.clearSelectedItem();
    this.clearItemDetails();
    this.clearItemRestoreDetails();
    this.clearEwayBill();
    this.clearSalesData();
    this.getSalesDefaultData();
  }

  clearSelectedItem() {
    this.selectedItem = {
      ic: '',
      refn: '',
      ina: '',
      sr: '',
      srafterdisc: '',
      srorg: '',
      mrp: '',
      currencysrorg: '',
      value: '',
      valueorg: '',
      taxvalue: '',
      discvalue: '',
      srwithtax: '',
      valuewithtax: '',
      qty: '',
      dp: '',
      tc: '',
      tp: '',
      sq: '',
      fd: '',
      bc: '',
      sdp: '',
      schemediscvalue: '',
      serialnumbers: [],
      reffield2: [],
      reffield3: [],
      reffield4: [],
      reffield5: [],
      reffield6: [],
      reffield7: [],
      reffield8: [],
      reffield9: [],
      reffield10: [],
      serialgodowncodes: [],
      serialgodownnames: [],
      batchno: '',
      mfgdate: '',
      expdate: '',
      description: '',
      ac: '',
      mrp_profitper: '',
      mrp_profitamt: '',
      sr_profitper: '',
      sr_profitamt: '',
      description2: '',
      description3: '',
      description4: '',
      description5: '',
      cesspercent: '',
      cessamount: '',
      dispname: '',
      extracessrate: '',
      extracessamount: '',
      uom: '',
      sgstpercent: '',
      sgstamount: '',
      cgstpercent: '',
      cgstamount: '',
      igstpercent: '',
      igstamount: '',
      mfrname: '',
      hsncode: '',
      hsnrefno: '',
      matrix1code: '',
      matrix1id: '',
      matrix1name: '',
      matrix2code: '',
      matrix2id: '',
      matrix2name: '',
      matrix3code: '',
      matrix3d: '',
      matrix3name: '',
      matrix4code: '',
      matrix4id: '',
      matrix4name: '',
      matrix5code: '',
      matrix5id: '',
      matrix5name: '',
      matrix6code: '',
      matrix6id: '',
      matrix6name: '',
      matrix7code: '',
      matrix7id: '',
      matrix7name: '',
      matrix8code: '',
      matrix8id: '',
      matrix8name: '',
      matrix9code: '',
      matrix9id: '',
      matrix9name: '',
      matrix10code: '',
      matrix10id: '',
      matrix10name: '',
      reftype: '',
      salespersoncode: '',
      salespersonname: '',
      returnbalqty: '',
      dcbillbalqty: '',
      rowno: '',
      dcdetails: [],
      editbeforedetails: {
        srorg: '',
        batchno: '',
        bc: '',
        matrix1code: '',
        matrix2code: '',
        matrix3code: '',
        matrix4code: '',
        matrix5code: '',
        matrix6code: '',
        matrix7code: '',
        matrix8code: '',
        matrix9code: '',
        matrix10code: ''
      },
      godowndetail: [],
      ssr: ''
    };
  }

  clearItemDetails() {
    this.itemDetails = {
      serialdetails: {
        reffield2: {
          required: '',
          mandatory: ''
        },
        reffield3: {
          required: '',
          mandatory: ''
        },
        reffield4: {
          required: '',
          mandatory: ''
        },
        reffield5: {
          required: '',
          mandatory: ''
        },
        reffield6: {
          required: '',
          mandatory: ''
        },
        reffield7: {
          required: '',
          mandatory: ''
        },
        reffield8: {
          required: '',
          mandatory: ''
        },
        reffield9: {
          required: '',
          mandatory: ''
        },
        reffield10: {
          required: '',
          mandatory: ''
        },
        reffielddisplaycolumns: []
      },
      matrixsetup: {
        matrix1: {
          required: ''
        },
        matrix2: {
          required: ''
        },
        matrix3: {
          required: ''
        },
        matrix4: {
          required: ''
        },
        matrix5: {
          required: ''
        },
        matrix6: {
          required: ''
        },
        matrix7: {
          required: ''
        },
        matrix8: {
          required: ''
        },
        matrix9: {
          required: ''
        },
        matrix10: {
          required: ''
        },
        matrixheaddisplaycolumns: [],
        matrixnamedisplaycolumns: []
      },
      branchwiseminmaxstocks: [],
      branchwisemrpdiscounts: [],
      branchwisepricing: [],
      branchwiseproducts: [],
      multibarcodes: [],
      quantitypricesetup: {
        qtywisepricing: []
      },
      margindetails: {
        mrpmargindetails: {
          mrpdisc1per: '',
          mrpdisc2per: '',
          mrpmargin: '',
          mrpmarkupper: '',
          mrpmarkdownper: '',
          mrpnetmargin: '',
          mrpnetmarginper: ''
        },
        purchasedetails: {
          prdiscper: '',
          prtaxvalue: '',
          prwithtax: ''
        },
        salesmargindetails: {
          srdiscper: '',
          srwithouttax: '',
          srtaxvalue: '',
          srmargin: '',
          srmarkupper: '',
          srmarkdownper: '',
          srnetmargin: '',
          srnetmarginper: ''
        },
        priceschemes: {
          dlrpdiscper: '',
          dlrpmarginper: '',
          dlrpmarginvalue: '',
          p1discper: '',
          p1marginper: '',
          p1marginvalue: '',
          p2discper: '',
          p2marginper: '',
          p2marginvalue: '',
          p3discper: '',
          p3marginper: '',
          p3marginvalue: '',
          p4discper: '',
          p4marginper: '',
          p4marginvalue: '',
          p5discper: '',
          p5marginper: '',
          p5marginvalue: '',
          p6discper: '',
          p6marginper: '',
          p6marginvalue: ''
        },
        roundoffnetvalues: ''
      },

      ic: '',
      ina: '',
      refn: '',
      sr: '',
      tp: '',
      cc: '',
      dp: '',
      da: '',
      unit: '',
      itemactive: '',
      reftype: '',
      stkchk: '',
      hsncode: '',
      taxcode: '',
      sq: '',
      fd: '',
      uomcode: '',
      subuomcode: '',
      mpchk: '',
      pr: '',
      mrp: '',
      dlrp: '',
      bc: '',
      bcm: '',
      pcm: '',
      p1: '',
      p2: '',
      p3: '',
      p4: '',
      p5: '',
      p6: '',
      d1: '',
      d2: '',
      d3: '',
      d4: '',
      d5: '',
      d6: '',
      netwt: '',
      grswt: '',
      imc: '',
      ilc: '',
      origincode: '',
      onlineallowed: '',
      mfgdateyn: '',
      expdays: '',
      cc2: '',
      cc3: '',
      cc4: '',
      cc5: '',
      itemtypecode: '',
      cesspercent: '',
      extracessrate: ''
    };
    this.constructSerials = [];
  }

  clearItemRestoreDetails() {
    this.itemRestoreData = {
      ic: '',
      refn: '',
      qr: '',
      srorg: '',
      currencysrorg: '',
      mrp: '',
      value: '',
      valueorg: '',
      taxvalue: '',
      discvalue: '',
      srwithtax: '',
      srafterdisc: '',
      valuewithtax: '',
      qty: '',
      dp: '',
      tc: '',
      tp: '',
      sq: '',
      fd: '',
      bc: '',
      sdp: '',
      schemediscvalue: '',
      ac: '',
      mrp_profitper: '',
      mrp_profitamt: '',
      sr_profitper: '',
      sr_profitamt: '',
      sgstpercent: '',
      sgstamount: '',
      cgstpercent: '',
      cgstamount: '',
      igstpercent: '',
      igstamount: '',
      reftype: '',
      cesspercent: '',
      cessamount: '',
      extracessrate: '',
      extracessamount: ''
    };
  }

  clearEwayBill() {
    this.ewayBillDetails = {
      einvoice_irn: (this.ewayBillDetails.einvoice_irn === '' ? '' : this.ewayBillDetails.einvoice_irn),
      eway_billno: '',
      eway_billdatetime: '',
      einvoice_irn_qr_image_base64: '',
      signed_invoice: '',
      signed_qrcode: '',
      ackno: '',
      ackdate: '',
      einvoice_cancelled: '',
      einvoice_cancelled_datetime: '',
      eway_billcancelled: '',
      transportmodecode: '1',
      transportmodename: '',
      transportdistance: '0',
      transportid: '',
      transportname: '',
      transportdocno: '',
      transportdate: '',
      vehicleno: '',
      vehicletypecode: '1',
      vehicletypename: '',
      cancelledreasonnotes: '',
    }
  }

  clearSalesData() {
    this.salesData = {
      tempsalesno: '',
      manualbillno: '',
      displaysalesno: '',
      branchcode: '',
      finyearcode: '',
      customercode: '',
      customername: '',
      address: '',
      salesdate: moment().format('DD/MM/YYYY'),
      customerpo: '',
      customerpodate: '',
      creditdays: '',
      salesnotes: '',
      paymentterms: '',
      deliverymode: '',
      noofpackages: '',
      ewaybillrefno: '',
      salestypecode: '',
      salestypename: '',
      salesaccountcode: '',
      salesaccountname: '',
      receiptmodecode: '',
      receiptmodename: '',
      costcentercode: '',
      costcentername: '',
      salestaxtype: '',
      salestaxinclusive: '',
      salesgsttype: '',
      currencyexchangerate: '',
      salescurrencycode: '',
      salescurrencyid: '',
      salesnetcurrencyvalue: '',
      subtotalamount: '',
      subtotalamountorg: '',
      billdiscountpercent: '',
      billdiscountamount: '',
      netamount: '',
      cashamount: '',
      cardamount: '',
      creditamount: '',
      chequeamount: '',
      freeamount: '',
      couponamount: '',
      othercardamount: '',
      rewardspentamount: '',
      returnadjustamount: '',
      tempexchangeno: '',
      nextsalesreminddate: '',
      bankcode: '',
      bankname: '',
      refno: '',
      date: '',
      tenderedamount: '',
      balancetopay: '',
      creditcardno: '',
      ourbankcode: '',
      ourbankname: '',
      cardtypecode: '',
      cardholdername: '',
      cardtypename: '',
      cardcompanytypecode: '',
      cardcompanytypename: '',
      cardservicechargespercent: '',
      cardservicechargesvalue: '',
      despatchaddress1: '',
      despatchaddress2: '',
      despatchaddress3: '',
      despatchaddress4: '',
      salespersoncode: '',
      salespersonname: '',
      totaltax: '',
      totalsgst: '',
      totalcgst: '',
      totaligst: '',
      totalgst: '',
      totalcharges: '',
      roundoffamount: '',
      createdby: '',
      createddatetime: '',
      approved: '',
      approvedby: '',
      approveddatetime: '',
      approval_timetaken: '',
      approval_timeelapsed: '',
      srallowed: '',
      contactcode: '',
      contactname: '',
      contactno: '',
      emailid: '',
      workphoneno: '',
      department: '',
      designation: '',
      exchangeno: '',
      dcwithtax: '',
      dcreturnable: '',
      dcbillable: '',
      dcreturnduedate: '',
      invoiceallowed: '',
      basedonno: '',
      basedondate: '',
      basedonname: '',
      questioncode: '',
      questionanswer: '',
      holdbill: 'NO',
      addbybarcode: 'NO',
      totalqty: 0,
      walletbankcode: '',
      entryupdatemode: '',
      salesentrytypename: 'SALES_INVOICE',
      available_items: [],
      unavailable_items: [],
      charges: [],
      taxsummary: [],
      documents: [],
      termsandconditions: [],
      advanceadjustments: [],
      returnadjustments: [],
      coupondetails: [],
      items: [],
      coupontotalsummary: {
        couponcount: '',
        copuonvalue: '',
        chargesvalue: '',
        couponnetvalue: ''
      },
      ewaybilldetails: {
        transportmodecode: '1',
        transportmodename: '',
        transportdistance: '0',
        transportid: '',
        transportname: '',
        transportdocno: '',
        transportdate: '',
        vehicleno: '',
        vehicletypecode: '1',
        vehicletypename: ''
      }
    };
    this.storage.remove('salesData');
  }

  clearAllTempData() {
    this.data.deleteData('draftstocks/clear').then((success) => {
    }, (error) => { });
  }

  // Get the Item Details and Item Restore Data;
  getData(val, xic, restore, xbc) {
    this.CloadingTrue = val;
    //  this.fullspinner.spin.next(true);
    // Getting the Item Details Data
    this.data.getData('item/' + xic + '/withdetails').then((success) => {
      this.responseData = success;
      //  this.fullspinner.spin.next(false);
      if (this.responseData.Status === true) {
        this.itemDetails = this.responseData.data;
        this.selectedItem.ina = this.itemDetails.ina;
        if (restore) {
          this.getItemRestoreData(this.CloadingTrue, xic, xbc);
        } else {
          this.CloadingTrue = false;
          this.callPopupfn();
        }

      } else {
        this.clearItemDetails();
      }
    }, (error) => {
      this.CloadingTrue = false;
    });
  }

  // Getting Item Restore Data
  getItemRestoreData(val, xic, xbc) {
    this.lastsaleratetrue = false;
    this.fullspinner.spin.next(true);
    if (this.barcode === 'BARCODE') {
      xbc = this.ic.barcoderefn;
    }
    const obj = {
      tempsalesno: this.salesData.tempsalesno,
      customercode: this.customer.customercode,
      salesentrytypename: 'SALES_INVOICE',
      salestaxtype: this.salesData.salestaxtype,
      salestaxinclusive: this.customer.advanced.taxinclusive,
      salesgsttype: this.salesData.salesgsttype,
      salescurrencycode: this.salesData.salescurrencycode,
      currencyexchangerate: this.salesData.currencyexchangerate,
      ratemodecode: 0,
      items: [
        {
          ic: xic,
          bc: xbc
        }
      ]
    };
    this.data.postData('sales/itemrestore', obj).then((success) => {
      this.responseData = success;
      this.fullspinner.spin.next(false);
      if (this.responseData.Status === true) {
        this.itemRestoreData = this.responseData.data;
        this.selectedItem.qty = this.itemRestoreData.qty;
        setTimeout(() => {
          this.callPopupfn();
          // tslint:disable-next-line: prefer-const
          let data = {};
          const setData = Object.assign(data, this.itemRestoreData);
          this.setItemRestoreDetails(data);
          if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'NO') {
            this.doConstructSerial();
          }
        }, 100);
        this.loadingTrue = false;
        if (this.customer.advanced.pricetypecode === '2' && (this.salesData.basedonname === '' || this.salesData.basedonname === 'None')) {
          this.getLastSaleRate();
        }

      } else {
        this.data.openAlert(this.responseData);
        this.clearItemRestoreDetails();
        this.loadingTrue = false;
      }
    }, (error) => {
      this.loadingTrue = false;
    });
  }

  getLastSaleRate() {
    this.lastsaleratetrue = false;
    const obj = {
      ic: this.selectedItem.ic,
      custcode: this.customer.customercode,
      excludebillno: (this.salesData.entryupdatemode === 'YES' ? this.salesData.tempsalesno : '')
    };
    this.data.postData('customer/lastsalerate', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.lastsaleratetrue = true;
        this.lastsalerate = this.responseData.lastsalerate;
      } else {
        this.lastsaleratetrue = false;
      }
    })
  }

  // set Item Resore Data with Selected Item
  setItemRestoreDetails(icrd) {
    this.clearSelectedItem();
    this.selectedItem.ina = this.itemDetails.ina;
    this.selectedItem.hsncode = this.itemDetails.hsncode;
    for (const key in this.selectedItem) {
      if (icrd[key]) {
        if (this.selectedItem[key] === icrd[key]) {
          continue;
        } else {
          this.selectedItem[key] = icrd[key];
        }
      }
    }
  }

  callPopupfn() {
    if (this.itemDetails.reftype === 'BATCH') {
      if (this.scanbarcode === 'SCANBARCODE' && this.itemDetails.bcm === 'Auto') {
        this.selectGodown();
      } else {
        this.getBatchStockDetails();
      }

    } else if (this.itemDetails.reftype === 'NONE' && this.itemDetails.stkchk === 'YES' && this.itemDetails.mpchk === 'YES') {
      if (this.scanbarcode === 'SCANBARCODE' && this.itemDetails.bcm === 'Auto') {
        this.selectGodown();
      } else {
        this.viewRatewiseStock();
      }

    } else if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'YES') {
      this.getSerialItem(true);
    } else if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'NO') {
      this.getStockReqNoItem();
    } else if (this.itemDetails.reftype === 'NONE' && this.itemDetails.stkchk === 'YES' && this.itemDetails.mpchk === 'NO') {
      this.selectGodown();
    } else if (this.itemDetails.reftype === 'MATRIX') {
      // this.selectGodown();
      if ((this.scanbarcode === 'SCANBARCODE' && this.itemDetails.bcm === 'Auto') || (this.barcode === 'BARCODE' && this.itemDetails.bcm === 'Auto')) {
        this.selectGodown();
      } else {
        this.getMatrix();
      }

    }
  }

  doSubmit() {
    if (this.salesData.tempsalesno !== '') {
      console.log(this.salesData.manualbillno);
      if (this.data.authorizationResponse.softwaresetup.data.sales_number_automatic_generation === 'NO' && this.manualbillno === '') {

        console.log('ok123');
        const obj = {
          Status: false,
          Message: 'Kindly Provide Invoice No'
        };
        this.data.openAlert(obj);
      }
      else if (this.data.authorizationResponse.softwaresetup.data.billvalue_zero_dontallow_onsales === 'YES' && this.salesData.netamount <= '0.00') {
        const obj = {
          Status: false,
          Message: 'Bill Value Is Zero'
        };
        this.data.openAlert(obj);
      }
      else {
        this.btnClicked = true;
        this.salesData.salesentrytypename = 'SALES_INVOICE';
        this.salesData.salestaxinclusive = this.customer.advanced.taxinclusive;
        this.salesData.salestaxtype = this.customer.advanced.taxtype;
        this.salesData.salesgsttype = this.customer.advanced.gsttype;
        this.customer.mobileno = '';
        if (this.salesData.entryupdatemode === 'NO') {
          this.salesData.manualbillno = this.manualbillno;
        } else {
          this.salesData.manualbillno = '';
        }

        this.data.postData('sales/confirm', this.salesData).then((success) => {
          this.responseData = success;
          if (this.responseData.Status === true) {
            this.clearAll();
            this.data.openAlert(this.responseData);
            this.btnClicked = false;
            const routeId = this.responseData.salesno;
            this.router.navigateByUrl('/home/sales/details/' + routeId + '/' + this.fycode + '/' + this.brcode);
            this.storage.remove('orderno');
            this.orderno = '';
          } else {
            if (this.responseData.questioncode) {
              if (parseFloat(this.responseData.questioncode) > 0) {
                this.doAskQuestion(this.responseData);
              } else {
                this.data.openAlert(this.responseData);
                this.btnClicked = false;
              }
            } else {
              this.data.openAlert(this.responseData);
              this.btnClicked = false;
            }
          }
        }, (error) => {

        });
      }
    }
  }

  doAskQuestion(val) {
    const dialogRef = this.dialog.open(AlertWindowComponent, {
      width: '350px',
      data: {
        msg: val.Message,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.salesData.questioncode = val.questioncode;
        this.salesData.questionanswer = 'YES';
        this.doSubmit();
      } else if (!result) {
        this.btnClicked = false;
      }
    });
  }

  doUpdateCharges(): void {
    const obj = {
      tempsalesno: this.salesData.tempsalesno,
      billdiscountpercent: this.salesData.billdiscountpercent,
      billdiscountamount: this.salesData.billdiscountamount,
      roundoffamount: this.salesData.roundoffamount,
      charges: this.salesData.charges
    };
    this.data.postData('sales/discountandcharges', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.getTempData(this.salesData.tempsalesno);
      }
      this.data.openAlert(this.responseData);
    }, (error) => {

    });
  }

  getGSTOnlineData(tempid) {
    if (this.data.token !== '') {
      this.addloadingTrue = false;
      const obj = {
        "entryno": tempid,
      };
      this.data.postData('sales/get/gstonlinedetails', obj).then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.ewayBillDetails = this.responseData.data;
          const qrdata = this.responseData.data.einvoice_irn_qr_image_base64.startsWith("data");
          if (qrdata === false) {
            this.ewayBillDetails.einvoice_irn_qr_image_base64 = 'data:image/png;base64,' + this.responseData.data.einvoice_irn_qr_image_base64;
          }
        } else {
          this.ewayBillDetails = {
            einvoice_irn: '',
            eway_billno: '',
            eway_billdatetime: '',
            einvoice_irn_qr_image_base64: '',
            signed_invoice: '',
            signed_qrcode: '',
            ackno: '',
            ackdate: '',
            einvoice_cancelled: '',
            einvoice_cancelled_datetime: '',
            eway_billcancelled: '',
            transportmodecode: '1',
            transportmodename: '',
            transportdistance: '0',
            transportid: '',
            transportname: '',
            transportdocno: '',
            transportdate: '',
            vehicleno: '',
            vehicletypecode: '1',
            vehicletypename: '',
            cancelledreasonnotes: '',
          }
         }
        this.addloadingTrue = false;
      }, (error) => {
        this.addloadingTrue = false;
      });
    } else {
      setTimeout(() => {
        this.getGSTOnlineData(tempid);
      }, 400);
    }
  }
  getSingleData(tempid) {
    if (this.data.token !== '') {
      this.loadingTrue = true;
      this.customerPOTrue = false;
      const obj = {
        "entryno": tempid,
        "entryfinyearcode": this.fycode,
        "entrybranchcode": this.brcode,
        "salesentrytypename": "SALES_INVOICE"
      };
      this.data.postData('sales/detail', obj).then((success) => {
        // this.data.getData('sales/' + tempid + '/detail').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.loadingTrue = false;
          this.salesData = this.responseData.data;
          this.customercode = this.salesData.customercode;
          this.customerChanged(false);
          this.getNewDisplayID(false);
          this.getSalesDocuments();
          setTimeout(() => {
            if (this.data.authorizationResponse.softwaresetup.data.sales_number_automatic_generation === 'NO' && this.manualbillno === '') {
              console.log(this.id);
              if (this.salesData.entryupdatemode === 'YES') {
                console.log(this.id);
                this.manualbillno = this.id;
              }
            }
          }, 400);
          if (this.salesData.basedonname === 'Order' && this.salesData.customerpo !== '') {
            this.customerPOTrue = true;
            console.log(this.customerPOTrue);
          } else {
            this.customerPOTrue = false;
          }
        } else {
          this.clearAll();
          this.clearAllTempData();
        }
        this.loadingTrue = false;
      }, (error) => {

      });
    } else {
      setTimeout(() => {
        this.getSingleData(tempid);
      }, 400);
    }
  }

  doUpdateRoundoff() {
    const obj = {
      tempsalesno: this.salesData.tempsalesno,
      roundoffamount: this.salesData.roundoffamount
    };
    this.data.postData('sales/roundoff', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.getTempData(this.salesData.tempsalesno);
      }
      this.data.openAlert(this.responseData);
    }, (error) => {
    });
  }

  updateRate() {
    if (parseFloat(this.selectedItem.qty) > 0) {
      if (this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'YES') {
        // this.selectedItem.currencysrorg = this.selectedItem.srorg;
        this.selectedItem.srorg = '';
      }
      this.fullspinner.spin.next(true);
      this.priceUpdate = true;
      const salesData = JSON.parse(JSON.stringify(this.salesData));
      salesData.salestaxinclusive = this.customer.advanced.taxinclusive;
      salesData.salestaxtype = this.salesData.salestaxtype;
      salesData.salesgsttype = this.salesData.salesgsttype;
      salesData.items = [];
      salesData.items.push(this.selectedItem);
      this.data.postData('sales/calculate/itemvalues', salesData).then((success) => {
        this.responseData = success;
        this.fullspinner.spin.next(false);
        if (this.responseData.Status === true) {
          const xydata = JSON.parse(JSON.stringify(this.selectedItem));
          if (this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'YES') {
            this.xrate = xydata.currencysrorg;
          } else {
            this.xrate = xydata.srorg;
          }
          this.xdisc = xydata.dp;
          this.xqty = xydata.qty;
          this.priceUpdate = false;
          this.updateJson(this.responseData.data);
        } else {
          this.priceUpdate = false;
          this.data.openAlert(this.responseData);
        }
      }, (error) => {

      });
    }
  }

  updateJson(newvalue) {
    for (const key in this.selectedItem) {
      if (newvalue[key]) {
        if (this.selectedItem[key] === newvalue[key]) {
          continue;
        } else {
          this.selectedItem[key] = newvalue[key];
        }
      }
    }
  }

  getBatchStockDetails(): void {
    const dialogRef = this.dialog.open(BatchStockdetailsComponent, {
      width: '700px',
      data: {
        ic: this.selectedItem.ic,
        qty: this.selectedItem.qty,
        entryname: 'SALES_INVOICE',
        supplierDC: 'NO',
        scanbarcode: this.scanbarcode,
        bc: this.scanbarcodeid,
        barcode: this.barcode,
        bbc: (this.barcode === 'BARCODE' ? this.ic.barcoderefn : '')
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.batchno = result.selectedbill.batchno;
        if (this.customer.advanced.pricetypecode != '1' && this.lastsaleratetrue === false) {
          this.selectedItem.srorg = result.selectedbill.salerate;
        }
        else if (this.customer.advanced.pricetypecode === '1') {
          if (this.customer.advanced.pricelistcode === '1') {
            this.selectedItem.srorg = result.selectedbill.price1;
          } else if (this.customer.advanced.pricelistcode === '2') {
            this.selectedItem.srorg = result.selectedbill.price2;
          } else if (this.customer.advanced.pricelistcode === '3') {
            this.selectedItem.srorg = result.selectedbill.price3;
          } else if (this.customer.advanced.pricelistcode === '4') {
            this.selectedItem.srorg = result.selectedbill.price4;
          } else if (this.customer.advanced.pricelistcode === '5') {
            this.selectedItem.srorg = result.selectedbill.price5;
          } else if (this.customer.advanced.pricelistcode === '6') {
            this.selectedItem.srorg = result.selectedbill.price6;
          } else {
            this.selectedItem.srorg = result.selectedbill.sr;
          }
        }

        if (this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'YES') {
          if (this.customer.advanced.pricetypecode != '1' && this.lastsaleratetrue === false) {
            this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.salerate) / parseFloat(this.salesData.currencyexchangerate)).toString();
          }
          else if (this.customer.advanced.pricetypecode === '1') {
            if (this.customer.advanced.pricelistcode === '1') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.price1) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '2') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.price2) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '3') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.price3) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '4') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.price4) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '5') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.price5) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '6') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.price6) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.salerate) / parseFloat(this.salesData.currencyexchangerate)).toString();
            }
          }
        }
        this.batchstocks = result.selectedbill.stock;
        if (this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.data.authorizationResponse.edition_features.multiwarehouses === 'YES') {
          if (result.selectedbill.batchno === '') { this.selectGodown(); }
          this.selectedItem.godowndetail = result.selectedbill.godowndetails;
          this.selectedItem.qty = result.qty;
        }
        this.updateRate();
      } else { this.selectGodown(); }
    });
  }

  viewRatewiseStock(): void {
    const dialogRef = this.dialog.open(RatewiseCurrentstockComponent, {
      width: '500px',
      data: {
        ic: this.selectedItem.ic,
        qty: this.selectedItem.qty,
        reftype: this.itemDetails.reftype,
        matrix1code: this.selectedItem.matrix1code,
        matrix2code: this.selectedItem.matrix2code,
        matrix3code: this.selectedItem.matrix3code,
        matrix4code: this.selectedItem.matrix4code,
        matrix5code: this.selectedItem.matrix5code,
        matrix6code: this.selectedItem.matrix6code,
        matrix7code: this.selectedItem.matrix7code,
        matrix8code: this.selectedItem.matrix8code,
        matrix9code: this.selectedItem.matrix9code,
        matrix10code: this.selectedItem.matrix10code,
        scanbarcode: this.scanbarcode,
        bc: this.scanbarcodeid,
        barcode: this.barcode,
        bbc: (this.barcode === 'BARCODE' ? this.ic.barcoderefn : '')
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.ssr = result.selectedbill.sr;
        if (this.customer.advanced.pricetypecode != '1' && this.lastsaleratetrue === false) {
          this.selectedItem.srorg = result.selectedbill.sr;
        }
        else if (this.customer.advanced.pricetypecode === '1') {
          if (this.customer.advanced.pricelistcode === '1') {
            this.selectedItem.srorg = result.selectedbill.p1;
          } else if (this.customer.advanced.pricelistcode === '2') {
            this.selectedItem.srorg = result.selectedbill.p2;
          } else if (this.customer.advanced.pricelistcode === '3') {
            this.selectedItem.srorg = result.selectedbill.p3;
          } else if (this.customer.advanced.pricelistcode === '4') {
            this.selectedItem.srorg = result.selectedbill.p4;
          } else if (this.customer.advanced.pricelistcode === '5') {
            this.selectedItem.srorg = result.selectedbill.p5;
          } else if (this.customer.advanced.pricelistcode === '6') {
            this.selectedItem.srorg = result.selectedbill.p6;
          } else {
            console.log('end');
            this.selectedItem.srorg = result.selectedbill.sr;
          }
        }


        if (this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'YES') {
          if (this.customer.advanced.pricetypecode != '1' && this.lastsaleratetrue === false) {
            this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.sr) / parseFloat(this.salesData.currencyexchangerate)).toString();
          }
          else if (this.customer.advanced.pricetypecode === '1') {
            if (this.customer.advanced.pricelistcode === '1') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.p1) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '2') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.p2) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '3') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.p3) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '4') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.p4) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '5') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.p5) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '6') {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.p6) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else {
              this.selectedItem.currencysrorg = (parseFloat(result.selectedbill.sr) / parseFloat(this.salesData.currencyexchangerate)).toString();
            }
          }
        }
        this.batchstocks = result.selectedbill.qty;
        if (this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.data.authorizationResponse.edition_features.multiwarehouses === 'YES') {
          if (result.selectedbill.sr === '') { this.selectGodown(); }
          this.selectedItem.godowndetail = result.selectedbill.godowndetails;
          this.selectedItem.qty = result.qty;
        }
        this.updateRate();
      } else { this.selectGodown(); }
    });
  }

  selectGodown(): void {
    if (this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.data.authorizationResponse.edition_features.multiwarehouses === 'YES') {
      const dialogRef = this.dialog.open(MultigodownSelectionComponent, {
        width: '700px',
        data: {
          ic: this.selectedItem.ic,
          ina: this.selectedItem.ina,
          qty: this.selectedItem.qty,
          godowndetail: this.selectedItem.godowndetail,
          entryname: 'SALES_INVOICE',
          scanbarcode: this.scanbarcode,
          sbc: this.scanbarcodeid,
          barcode: this.barcode,
          bbc: (this.barcode === 'BARCODE' ? this.ic.barcoderefn : ''),
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.selectedItem.godowndetail = result.godowndetail;
          this.selectedItem.qty = result.qty;
          this.updateRate();
        }
      });
    }
  }

  selectGodownforEdit(el:any) {
    if (this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.data.authorizationResponse.edition_features.multiwarehouses === 'YES') {
      const dialogRef = this.dialog.open(MultigodownSelectionComponent, {
        width: '700px',
        data: {
          ic: this.selectedItem.ic,
          ina: this.selectedItem.ina,
          qty: this.selectedItem.qty,
          godowndetail: this.selectedItem.godowndetail,
          entryname: 'SALES_INVOICE',
          scanbarcode: this.scanbarcode,
          sbc: this.scanbarcodeid,
          barcode: this.barcode,
          bbc: (this.barcode === 'BARCODE' ? this.ic.barcoderefn : ''),
          addCal:'NONE',
          bc:el.bc,
          batchno:el.batchno,
          matrix1code: el.matrix1code,
          matrix2code: el.matrix2code,
          matrix3code: el.matrix3code,
          matrix4code: el.matrix4code,
          matrix5code: el.matrix5code,
          matrix6code: el.matrix6code,
          matrix7code: el.matrix7code,
          matrix8code: el.matrix8code,
          matrix9code: el.matrix9code,
          matrix10code: el.matrix10code,


        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.selectedItem.godowndetail = result.godowndetail;
          el.godowndetail = result.godowndetail;
          this.selectedItem.qty = result.qty;
          this.updateRate();
        }
      });
    }
  }

  getSerialItem(val): void {
    let entryupdatemode = 'NO';
    this.buttonEditTrue = false;
    if (this.button === 'Edit') {
      entryupdatemode = 'YES'
      this.buttonEditTrue = true;
    }
    const dialogRef = this.dialog.open(SelectSerialInvoiceComponent, {
      width: '600px',
      data: {
        ic: this.selectedItem.ic,
        serialnumbers: this.selectedItem.serialnumbers,
        ina: this.selectedItem.ina,
        qty: this.selectedItem.qty,

        entryupdatemode: entryupdatemode,
        entryname: 'SALES_INVOICE',
        entryno: this.salesData.tempsalesno,
        entrybranchcode: this.brcode,
        entryfinyearcode: this.fycode,
        basedonname: this.salesData.basedonname,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.serialnumbers = result.selectedserial;
        this.selectedItem.qty = result.selectedserial.length;
        this.selectedItem.ssr = result.salerate;
        console.log(this.buttonEditTrue);
        if (this.customer.advanced.pricetypecode != '1' && this.lastsaleratetrue === false) {
          if (this.buttonEditTrue === false) {
            this.selectedItem.srorg = result.salerate;
          }
        }
        else if (this.customer.advanced.pricetypecode === '1') {
          if (this.customer.advanced.pricelistcode === '1') {
            this.selectedItem.srorg = result.p1;
          } else if (this.customer.advanced.pricelistcode === '2') {
            this.selectedItem.srorg = result.p2;
          } else if (this.customer.advanced.pricelistcode === '3') {
            this.selectedItem.srorg = result.p3;
          } else if (this.customer.advanced.pricelistcode === '4') {
            this.selectedItem.srorg = result.p4;
          } else if (this.customer.advanced.pricelistcode === '5') {
            this.selectedItem.srorg = result.p5;
          } else if (this.customer.advanced.pricelistcode === '6') {
            this.selectedItem.srorg = result.p6;
          } else {
            console.log('end');
            this.selectedItem.srorg = result.selectedbill.sr;
          }
        }

        // this.salesData.basedonname === 'None' || this.salesData.basedonname === ''
        if (this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'YES') {
          if (this.customer.advanced.pricetypecode != '1' && this.lastsaleratetrue === false) {
            if (this.buttonEditTrue === false) {
              this.selectedItem.currencysrorg = (parseFloat(result.salerate) / parseFloat(this.salesData.currencyexchangerate)).toString();
            }
          }
          else if (this.customer.advanced.pricetypecode === '1') {
            if (this.customer.advanced.pricelistcode === '1') {
              this.selectedItem.currencysrorg = (parseFloat(result.p1) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '2') {
              this.selectedItem.currencysrorg = (parseFloat(result.p2) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '3') {
              this.selectedItem.currencysrorg = (parseFloat(result.p3) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '4') {
              this.selectedItem.currencysrorg = (parseFloat(result.p4) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '5') {
              this.selectedItem.currencysrorg = (parseFloat(result.p5) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else if (this.customer.advanced.pricelistcode === '6') {
              this.selectedItem.currencysrorg = (parseFloat(result.p6) / parseFloat(this.salesData.currencyexchangerate)).toString();
            } else {
              this.selectedItem.currencysrorg = (parseFloat(result.salerate) / parseFloat(this.salesData.currencyexchangerate)).toString();
            }
          }
        }
        this.selectedItem.serialgodowncodes = result.selectedserialgodowncodes;
        this.updateRate();
      }
      this.getDataObservable.next({ response: true, type: 'serial' });
    });
  }

  getStockReqNoItem(): void {
    const dialogRef = this.dialog.open(SelectserialStockreqNoitemComponent, {
      width: '500px',
      data: {
        ic: this.selectedItem.ic,
        constructSerials: this.constructSerials,
        ina: this.selectedItem.ina,
        qty: this.selectedItem.qty,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.serialnumbers = result.itemData.serialstocks.serialnumbers;
        this.selectedItem.reffield2 = result.itemData.serialstocks.reffield2;
        this.selectedItem.reffield3 = result.itemData.serialstocks.reffield3;
        this.selectedItem.reffield4 = result.itemData.serialstocks.reffield4;
        this.selectedItem.reffield5 = result.itemData.serialstocks.reffield5;
        this.selectedItem.reffield6 = result.itemData.serialstocks.reffield6;
        this.selectedItem.reffield7 = result.itemData.serialstocks.reffield7;
        this.selectedItem.reffield8 = result.itemData.serialstocks.reffield8;
        this.selectedItem.reffield9 = result.itemData.serialstocks.reffield9;
        this.selectedItem.reffield10 = result.itemData.serialstocks.reffield10;
        this.selectedItem.qty = result.construct.length;
      }
      this.getDataObservable.next({ response: true, type: 'serial' });
    });
  }

  getMatrix(): void {
    const dialogRef = this.dialog.open(MatrixSelectionComponent, {
      width: '900px',
      data: {
        ic: this.selectedItem.ic,
        ina: this.selectedItem.ina,
        matrix1code: this.selectedItem.matrix1code,
        matrix2code: this.selectedItem.matrix2code,
        matrix3code: this.selectedItem.matrix3code,
        matrix4code: this.selectedItem.matrix4code,
        matrix5code: this.selectedItem.matrix5code,
        matrix6code: this.selectedItem.matrix6code,
        matrix7code: this.selectedItem.matrix7code,
        matrix8code: this.selectedItem.matrix8code,
        matrix9code: this.selectedItem.matrix9code,
        matrix10code: this.selectedItem.matrix10code,
        matrixsetup: this.itemDetails.matrixsetup
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedItem.matrix1code = result.selectedbill.matrix1code;
        this.selectedItem.matrix2code = result.selectedbill.matrix2code;
        this.selectedItem.matrix3code = result.selectedbill.matrix3code;
        this.selectedItem.matrix4code = result.selectedbill.matrix4code;
        this.selectedItem.matrix5code = result.selectedbill.matrix5code;
        this.selectedItem.matrix6code = result.selectedbill.matrix6code;
        this.selectedItem.matrix7code = result.selectedbill.matrix7code;
        this.selectedItem.matrix8code = result.selectedbill.matrix8code;
        this.selectedItem.matrix9code = result.selectedbill.matrix9code;
        this.selectedItem.matrix10code = result.selectedbill.matrix10code;
        this.viewRatewiseStock();
      }
    });
  }

  exractSerial() {
    return new Promise((res, rej) => {
      let yesConstruct = false;
      if (this.itemDetails.reftype === 'SERIAL') {
        this.selectedItem.serialnumbers = [];
        this.selectedItem.serialgodowncodes = [];
        this.selectedItem.reffield2 = [];
        this.selectedItem.reffield3 = [];
        this.selectedItem.reffield4 = [];
        this.selectedItem.reffield5 = [];
        this.selectedItem.reffield6 = [];
        this.selectedItem.reffield6 = [];
        this.selectedItem.reffield7 = [];
        this.selectedItem.reffield8 = [];
        this.selectedItem.reffield9 = [];
        this.selectedItem.reffield10 = [];
        this.constructSerials.forEach(element => {
          this.selectedItem.serialnumbers.push(element.serialnumbers);
          this.selectedItem.reffield2.push(element.reffield2);
          this.selectedItem.reffield3.push(element.reffield3);
          this.selectedItem.reffield4.push(element.reffield4);
          this.selectedItem.reffield5.push(element.reffield5);
          this.selectedItem.reffield6.push(element.reffield6);
          this.selectedItem.reffield7.push(element.reffield7);
          this.selectedItem.reffield8.push(element.reffield8);
          this.selectedItem.reffield9.push(element.reffield9);
          this.selectedItem.reffield10.push(element.reffield10);
        });
        yesConstruct = true;
      }
      res(yesConstruct);
    });
  }

  doConstructSerial() {
    // First Check the length of constructSerials
    const xlength = this.constructSerials.length;
    let obj = {
      serialnumbers: '',
      serialgodowncodes: {
        godowncode: '',
        godownname: ''
      },
      reffield2: '',
      reffield3: '',
      reffield4: '',
      reffield5: '',
      reffield6: '',
      reffield7: '',
      reffield8: '',
      reffield9: '',
      reffield10: ''
    };
    if (xlength < 1) {
      for (let i = 0; i < parseFloat(this.selectedItem.qty); i++) {
        obj = {
          serialnumbers: this.selectedItem.serialnumbers[i] ? this.selectedItem.serialnumbers[i] : '',
          serialgodowncodes: {
            godowncode: this.selectedItem.serialgodowncodes[i] ? this.selectedItem.serialgodowncodes[i] : '',
            godownname: this.selectedItem.serialgodownnames[i] ? this.selectedItem.serialgodownnames[i] : ''
          },
          reffield2: this.selectedItem.reffield2[i] ? this.selectedItem.reffield2[i] : '',
          reffield3: this.selectedItem.reffield3[i] ? this.selectedItem.reffield3[i] : '',
          reffield4: this.selectedItem.reffield4[i] ? this.selectedItem.reffield4[i] : '',
          reffield5: this.selectedItem.reffield5[i] ? this.selectedItem.reffield5[i] : '',
          reffield6: this.selectedItem.reffield6[i] ? this.selectedItem.reffield6[i] : '',
          reffield7: this.selectedItem.reffield7[i] ? this.selectedItem.reffield7[i] : '',
          reffield8: this.selectedItem.reffield8[i] ? this.selectedItem.reffield8[i] : '',
          reffield9: this.selectedItem.reffield9[i] ? this.selectedItem.reffield9[i] : '',
          reffield10: this.selectedItem.reffield10[i] ? this.selectedItem.reffield10[i] : ''
        };
        this.constructSerials.push(JSON.parse(JSON.stringify(obj)));
      }
    } else {
      // compare the length with the qty;
      const xqty = parseFloat(this.selectedItem.qty);
      const diff = xqty - xlength;
      if (diff > 0) {
        for (let i = 0; i < diff; i++) {
          this.constructSerials.push(JSON.parse(JSON.stringify(obj)));
        }
      } else if (diff < 0) {
        const xnum = diff * -1;
      }
    }
  }

  getDataEdit(val, xic, restore, xbc) {
    this.CloadingTrue = val;
    this.fullspinner.spin.next(true);
    // Getting the Item Details Data
    this.data.getData('item/' + xic + '/withdetails').then((success) => {
      this.responseData = success;
      this.fullspinner.spin.next(false);
      if (this.responseData.Status === true) {
        this.itemDetails = this.responseData.data;
        this.selectedItem.ina = this.itemDetails.ina;
        console.log('Data2');
        if (restore) {
          console.log('Data3');
          this.getItemRestoreData(this.CloadingTrue, xic, xbc);
          console.log('Data4');
        } else {
          this.CloadingTrue = false;
          this.callPopupfnEdit();
        }

      } else {
        this.clearItemDetails();
      }
    }, (error) => {
      this.CloadingTrue = false;
    });
  }

  callPopupfnEdit() {
    if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'YES') {
      this.getSerialItem(true);

    } else if (this.itemDetails.reftype === 'SERIAL' && this.itemDetails.stkchk === 'NO') {
      this.getStockReqNoItem();

    }
  }

  getCustomerAdvaces() {
    if (this.data.token !== '') {
      // this.loadingTrue = true;

      const obj = {
        customercode: this.customercode,
        currencycode: this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'YES' ? this.salesData.salescurrencycode : "0",
        salesno: this.salesData.entryupdatemode === "YES" ? this.salesData.tempsalesno : '',
        salesfinyearcode: this.salesData.entryupdatemode === "YES" ? this.salesData.finyearcode : "0",
        orderno: this.salesData.basedonname === "Order" ? this.salesData.basedonno : this.orderno,
        dcnos: this.salesData.basedonname === "DC" ? this.dcnos : []
      };
      this.data.postData('customer/advances', obj).then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.customeradvances = this.responseData.data;
          this.customeradvances.forEach(element => {
            const el = JSON.parse(JSON.stringify(element));
            element.xadjustedamount = el.adjustedamount;
            element.xforexadjustedamount = el.forexadjustedamount;
          });
        } else {
          this.customeradvances = [];
        }
        this.loadingTrue = false;
      }, (error) => {
        this.data.errorResponse(error);
      });
    } else {
      setTimeout(() => {
        this.getCustomerAdvaces();
      }, 400);
    }
  }

  getGodownStocks() {
    const obj = {
      ic: this.selectedItem.ic,
      matrix1code: this.selectedItem.matrix1code,
      matrix2code: this.selectedItem.matrix2code,
      matrix3code: this.selectedItem.matrix3code,
      matrix4code: this.selectedItem.matrix4code,
      matrix5code: this.selectedItem.matrix5code,
      matrix6code: this.selectedItem.matrix6code,
      matrix7code: this.selectedItem.matrix7code,
      matrix8code: this.selectedItem.matrix8code,
      matrix9code: this.selectedItem.matrix9code,
      matrix10code: this.selectedItem.matrix10code,
      searchitem: '',
      batchno: this.selectedItem.batchno,
      entryupdatemode: 'no',
      entryname: '',
      entryno: '',
      entrybranchcode: '',
      entryfinyearcode: ''
    };
    this.data.postData('search/godownstocks', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.godowns = this.responseData.data;
        this.godowns.forEach(element => {
          const el = JSON.parse(JSON.stringify(element));
          element.xstockqty = el.stock;
        });
      } else {
        this.godowns = [];
      }
      this.loadingTrue = false;
    }, (error) => {
      this.data.errorResponse(error);
    });
  }

  getSalesDocuments() {
    const obj = {
      entryno: this.salesData.displaysalesno,
      documententrytypecode: 0
    };
    this.data.postData('documents/list', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.salesData.documents = this.responseData.data;
      }
      else {
        this.salesData.documents = [];
      }
    }, (err) => {
    });
  }

  updateRateCalculation() {
    let temporg = 0;
    let temprate = 0;
    let tempvalue = 0;
    if (this.data.authorizationResponse.softwaresetup.data.multicurrencyonsales === 'NO') {
      temporg = parseFloat(this.selectedItem.srorg);
    } else {
      temporg = parseFloat(this.selectedItem.currencysrorg) * parseFloat(this.salesData.currencyexchangerate);
    }
    if (parseFloat(this.selectedItem.qty) > 0) {
      if (this.salesData.salestaxtype === 'NOTAX' || this.selectedItem.tp <= '0' || ((this.salesData.salestaxtype === 'VAT' || this.salesData.salestaxtype === 'GST') && this.customer.advanced.taxinclusive === 'NO')) {
        temprate = (temporg - (temporg * parseFloat(this.selectedItem.dp)) / 100);
        tempvalue = (parseFloat(temprate.toFixed()) * parseFloat(this.selectedItem.qty));
        this.selectedItem.value = tempvalue.toFixed(2);
      } else {
        temprate = (temporg - parseFloat(this.selectedItem.extracessrate));
        temprate = (temprate - (temprate * parseFloat(this.selectedItem.dp)) / 100);
        temprate = (temprate * 100) / (100 + (parseFloat(this.selectedItem.tp) + parseFloat(this.selectedItem.cesspercent)));
        tempvalue = temprate * parseFloat(this.selectedItem.qty);
        this.selectedItem.value = tempvalue.toFixed(2);
      }
    }
  }

}
